@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Illinois</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">{{ getBodilyInjuryCoverageHeading() }}</h3>
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }
      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 2 : 10; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  [innerHTML]="control.label"
                >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <div class="axis-grid">
        @if ((baseRules?.["UMBI_SplitLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label
                class="axis-control-label"
                [innerHTML]="controls[2].label"
              ></label>
              <div id="umbi_splitlimits_25k_50k-pdffield-illinois">
                {{ controls[2].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_CombinedSingleLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label
                class="axis-control-label"
                [innerHTML]="controls[3].label"
              ></label>
              <div id="umbi_combinedsinglelimit_50k-pdffield-illinois">
                {{ controls[3].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label
                class="axis-control-label"
                [innerHTML]="controls[4].label"
              ></label>
              <div id="umbi_splitminlimits_25k_50k-pdffield-illinois">
                {{ controls[4].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label
                class="axis-control-label"
                [innerHTML]="controls[5].label"
              ></label>
              <div id="umbi_combinedsingleminlimit_50k-pdffield-illinois">
                {{ controls[5].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      @if ((baseRules?.["LiabilityLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6 axis-grid">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              [innerHTML]="controls[12].label"
            ></label>
            <div id="liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-illinois">
              {{ controls[12].data[0].name }}
            </div>
          </div>
        </div>
      }

      <h3 class="axis-h5">
        UM Property Damage Coverage (Applies to Private Passenger or Recreational Motor Vehicles Only):
      </h3>

      <!-- UIM Radio group level one -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UMPD Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 9; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  [innerHTML]="control.label"
                >
                </label>
                <axis-dropdown
                  (onSelect)="onDropdownSelect(control, $event)"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
                @if (control.selectedPremium) {
                  <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <!--Readonly dropdowns-->
      @if ((baseRules?.["UMPD_CoverageMin_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              [innerHTML]="controls[11].label"
            ></label>
            <div id="umpd_coveragemin_15k-pdffield-illinois">
              {{ controls[11].data[0].name }}
            </div>
          </div>
        </div>
      }
      <!--Reject UIM Readonly-->
      @if ((baseRules?.["Reject_UMPD_LevelOne_Radio"] || "").includes("Yes")) {
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="reject_umpd_levelone_radio-pdffield-illinois"
          >
            {{ textValues?.Reject_UMPD_Text }}
          </label>
        </div>
      }
    </form>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Illinois</h2>
  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 2 : 6; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              [innerHTML]="control.label"
            ></label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>

  @if (baseRules?.LiabilityLimit_DropDown) {
    <div class="axis-col-sm-12 axis-col-lg-12 axis-grid">
      <div class="axis-form-group">
        <label class="axis-control-label"> {{ controls?.[12]?.label }} </label>
        <div>{{ controls?.[12]?.data?.[0]?.name }}</div>
      </div>
    </div>
  }

  <!-- Reject texts -->
  @if (baseRules?.Reject_UMPD_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_UMPD_Text }}
      </label>
    </div>
  }
}
